<template>
  <div id="tela-selfie">
    <div class="captura" :class="{'hidden':isError}">
      <div id="liveness-caf"></div>
    </div>

    <div class="page-error margem-app">
      <Error
          v-if="isError"
          :title="error.title"
          :subtitle="error.subtitle"
          :button-text="error.btnTitle"
          v-bind:callback="error.primaryCallback || this.reloadComponent"
          :dispatch-tag="error.dispatchTag"
          :secound-button-text="error.secoundButtonText"
          :secound-button-callback="error.secoundButtonCallback"
      ></Error>
    </div>
  </div>

</template>

<script>

import Error from "../shared/Error";
import AppService from "../../services/AppService";
import LivenessLogService from "../../services/LivenessLogService";
import jwtDecode from "jwt-decode";
import DispatchTags from "../../utils/DispatchTags";
import CapturaService from "../../services/CapturaService";

const ERROR = {
  title: "Não conseguimos tirar a foto do seu rosto",
  subtitle: "Não localizamos seu rosto para tirar a foto. Centralize ele na moldura e tente novamente",
  btnTitle: "Tentar novamente",
};

const ERROR_NUDEZ = {
  title: "Sua foto não foi tirada",
  subtitle: "Você precisa usar uma blusa ou camiseta para tirar a sua foto",
  btnTitle: "Tentar novamente",
  secoundButtonText: "Ir para o início"
};

const ERROR_ACESSO_CAMERA = {
  title: "Algo deu errado ao acessar sua câmera",
  subtitle: "Para continuar, permita o acesso nas configurações do seu aparelho para tirarmos sua foto e confirmar sua identidade",
  btnTitle: "Ir para o início",
};
const EVENTS_CAF = {
  started: 'started',
  sdk_button_ready:'sdk-button-ready',
  passed: 'passed',
  failed:'failed',
  error:'error',
  streaming: 'streaming',
  streamed: 'streamed',
  canceled: 'canceled',
  permission: 'permission',
  permission_denied: 'permission_denied',
  unsupported:'unsupported'
};

const LIVENESS_CONFIG = {
  htmlContainerId: "liveness-caf",
  cameraPreviewFilter: "clear"
};

const LIVENESS_CUSTOMIZATION = {
  startButton: {
    label: 'Estou Pronto',
    color: '#FFF',
    backgroundColor: '#660099',
    borderRadius: '24px',
    border: '1px solid transparent'
  }
};

export default {
  name: "LivenessCaf",
  components: {Error},
  data(){
    return {
      isError: false,
      error: {
        title: ERROR.title,
        subtitle: ERROR.subtitle,
        btnTitle: ERROR.btnTitle,
        dispatchTag: null,
        secoundButtonText: null,
        secoundButtonCallback: null,
        primaryCallback: null
      },
      eventError:'',
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => vm.listenerEvents());
  },
  beforeRouteLeave(to, from,next) {
    this.removeListeners();
    next();
  },
  created() {
    this.$store.dispatch("setTitulo", "Confirmar identidade");
    this.$store.dispatch("setLoadingStatus", true);
  },
  mounted() {
    this.logLivenessService = new LivenessLogService();
    this.appService = new AppService();
    this.appService.carregarComponentSelefie();
    var interval = setInterval(_ => {
      if (!this.$store.getters.componenteSelfieCarregado) {
        return;
      }
      this.selfie = window.selfie;
      this.iniciarSelfie();
      clearInterval(interval);
    }, 100);
  },
  methods:{
    iniciarSelfie:async function (){
      const CafFaceLivenessSdk = window['CafFaceLiveness'];
      try {
        const token = this.$store.state.token_caf;
        const data = jwtDecode(token);
        await CafFaceLivenessSdk.init(token, data.peopleId, LIVENESS_CONFIG, LIVENESS_CUSTOMIZATION);
        const result = await CafFaceLivenessSdk.run();
        await this.waitResult(result);
      } catch (error) {
         switch (error.name) {
           case "CafCameraPermissionError":
           case "CafCameraPermissionDeniedError":
             let e = ERROR_ACESSO_CAMERA;
             this.showError(e.title,e.subtitle,e.btnTitle);
             break;
           default:
             this.showError('',error.message ?  error.message  :  ERROR.subtitle );
             break;
         }
      }finally {
        this.disposeCaf(CafFaceLivenessSdk);
      }
    },
    handleEvents(event){
      switch (event.type){
        case EVENTS_CAF.permission:
        case EVENTS_CAF.sdk_button_ready:
          this.$store.dispatch("setLoadingStatus", false);
          break;
        case EVENTS_CAF.passed:
          this.$store.dispatch("setLoadingStatus", true);
          break;
        case EVENTS_CAF.permission_denied:
          let e = ERROR_ACESSO_CAMERA;
          this.showError(e.title,e.subtitle,e.btnTitle);
          break;
        case EVENTS_CAF.unsupported:
        case EVENTS_CAF.canceled:
        case EVENTS_CAF.failed:
        case EVENTS_CAF.error:
          this.$store.dispatch("setLoadingStatus", true);
          this.eventError = event;
          break;
      }
    },
    async waitResult(signedResponse){
      try{
        this.$store.dispatch("setLoadingStatus", true);
        const capturaService = new CapturaService();
        const result = await  capturaService.validateSelfieCaf(signedResponse);
        if(!result){
          throw new Error('Falha ao validar sua selfie, por favor tente novamente.');
        }
        if(result && result.status !== 200 && result.type !== 'success'){
          throw new Error(result.message ? result.message : '');
        }
        sessionStorage.setItem("s", signedResponse);
        sessionStorage.setItem("iscaf", true);
        this.nextPage();
      }catch (e){
        if(e && e.status === 417){
          this.showErrorNudez()
          return;
        }
        if(typeof this.eventError === 'object'){
          this.tratarEventErros(this.eventError);
          return;
        }
        this.errorGedocValidateImages(e);
      }
    },
    showErrorNudez(){
      DispatchTags.dispatchScreenView('SelfieErrorNudez');
      DispatchTags.dispatchNoninteraction('SelfieErrorNudez');
      this.showError(ERROR_NUDEZ.title, ERROR_NUDEZ.subtitle, ERROR_NUDEZ.btnTitle, this.reloadPageErrorNudez, ERROR_NUDEZ.secoundButtonText, () => {
        DispatchTags.dispatchInraction('SelfieErrorNudez');
        this.reloadComponent();
      });
    },
    listenerEvents(){
      Object.values(EVENTS_CAF).forEach(eventType => {
        document.addEventListener(eventType, this.handleEvents);
      });
    },
    removeListeners(){
      Object.values(EVENTS_CAF).forEach(eventType => {
        document.removeEventListener(eventType,this.handleEvents);
      });
    },
    reloadComponent() {
      this.$store.dispatch("setLoadingStatus", true);
      this.$router.replace({name:'ConfirmarIdentidade'});
    },
    reloadPageErrorNudez() {
      this.$store.dispatch("setLoadingStatus", true);
      DispatchTags.dispatchInraction('SelfieErrorNudez');
      this.iniciarSelfie();
      this.isError = false;
    },
    nextPage(){
      this.appService.nextPageLiveness();
    },
    showError(title, subtitle, btnTitle, primaryCallback = null, secoundButtonText = null, secoundButtonCallback = null) {
      if (this.isError) {
        return;
      }
      this.error.title = title ? title : ERROR.title;
      this.error.subtitle = subtitle ? subtitle : ERROR.subtitle;
      this.error.btnTitle = btnTitle ? btnTitle : ERROR.btnTitle;
      this.error.primaryCallback = primaryCallback;
      this.error.secoundButtonText = secoundButtonText;
      this.error.secoundButtonCallback = secoundButtonCallback;
      this.isError = true;
      this.$store.dispatch("setLoadingStatus", false);
    },
    disposeCaf(CafFaceLivenessSdk){
      try {
        CafFaceLivenessSdk.dispose();
      } catch (error) {
        console.error("CAF Dispose error:", error.name, error.message);
      }
    },
    tratarEventErros(event){
      let reasonMessage = '';
      if (event.detail && event.detail.reason) {
        reasonMessage = event.detail.reason;
      }

      let feedback = '';
      if(event.detail && event.detail.feedback){
        feedback = event.detail.feedback;
      }
      this.showError('',reasonMessage);
      this.eventError = '';
    },
    errorGedocValidateImages(e){
      let mensagem = '';
      if(typeof e === 'string'){
        mensagem  = e;
      }
      if (e && e.body && e.body.message) {
        mensagem = e.body.message;
      }
      this.showError('',mensagem);
    },
  },
}
</script>

<style scoped>
#liveness-caf{
  display: flex;
  justify-content: center;
}
.hidden {
  display: none !important;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/LivenessCaf.vue